import React from 'react';
import ReactDOM from 'react-dom';

export interface PortalProps {
  /** children node */
  children: React.ReactNode;
  /** At which node the portal to be created? */
  node?: HTMLElement;
}

export const Portal: React.FC<PortalProps> = ({
  children,
  node,
}: PortalProps) => {
  return ReactDOM.createPortal(children, node || document.body);
};
